import axios from '@axios'
import useJwt from '@/auth/jwt/useJwt'

const { jwt } = useJwt(axios, {})
export default jwt